"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.reduce.js");
require("core-js/modules/es.json.stringify.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _vuexModuleDecorators = require("vuex-module-decorators");
var _products = require("@/api/products");
var _categories = require("@/api/categories");
var _taxes = require("@/api/master/taxes");
var _brands = require("@/api/brands");
var _utils = require("@/utils");
var _index = _interopRequireDefault(require("@/components/HelpText/index.vue"));
require("tinymce/tinymce");
require("tinymce/themes/silver");
require("tinymce/icons/default");
require("tinymce/skins/ui/oxide/skin.css");
var _tinymceVue = _interopRequireDefault(require("@tinymce/tinymce-vue"));
require("tinymce/plugins/lists");
require("tinymce/plugins/link");
require("tinymce/plugins/image");
require("tinymce/plugins/paste");
require("tinymce/plugins/help");
require("tinymce/plugins/wordcount");
require("tinymce/plugins/preview");
require("tinymce/plugins/table");
require("tinymce/plugins/code");
var _router = _interopRequireDefault(require("@/router"));
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.loading = false;
    this.rules = {
      name: [{
        required: true,
        message: 'Please enter name',
        trigger: 'blur'
      }, {
        min: 3,
        message: 'Minimum length should be 3',
        trigger: 'blur'
      }]
    };
    this.savedSimpleVariation = [];
    this.savedVariableVariations = [];
    this.inputTagVisible = false;
    this.inputTagValue = '';
    this.taxes = [];
    this.brandsList = [];
    this.productsList = [];
    this.selectedRelatedProduct = [];
    this.selectedParentId = null;
    this.categoryList = [];
    this.parentCategories = null;
    this.selectedCategoryId = null;
    this.activeName = '1';
  }
  submitForm(exit = false) {
    var _this$formData;
    if (((_this$formData = this.formData) === null || _this$formData === void 0 ? void 0 : _this$formData.productType) === 'simple' && this.formData.productsVariation.length) {
      const salePrice = this.formData.productsVariation[0].salePrice;
      if (salePrice === undefined || salePrice === null || +salePrice <= 0) {
        this.$message.error('Sale Price is required and must be greater than 0!');
        return false;
      }
    }
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm(exit);
      } else {
        this.$message.error('Failed to saved!');
        return false;
      }
    });
  }
  created() {
    this.getTaxes();
    this.getCategoriesList();
    this.getBrandsList();
    if (this.isEdit) {
      const productId = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(productId));
    }
    // this.gethis.formData = data;tProductsList();
  }
  async fetchData(id) {
    try {
      const data = await (0, _products.getProductById)(id);
      Object.assign(this.formData, data);
      // --- UPDATED CATEGORY LOGIC ---
      if (data.category) {
        if (Array.isArray(data.category) && data.category.length) {
          // If backend still returns an array, just grab the first one
          this.selectedCategoryId = data.category[0].id;
        } else if (data.category.id) {
          // If backend returns a single object
          this.selectedCategoryId = data.category.id;
        }
      }
      // -------------------------------
      if (this.formData.relatedProduct && this.formData.relatedProduct.length) {
        this.selectedRelatedProduct = this.formData.relatedProduct.map(relatedProduct => relatedProduct.id);
        const products = [];
        this.formData.relatedProduct.forEach(value => {
          products.push({
            id: value.id,
            name: value.name
          });
        });
        this.productsList = products;
      }
    } catch (err) {
      // redirect
      _router.default.push({
        path: '/product/list/',
        query: this.$route.query // Pass all current query parameters
      });
    }
  }
  toggleProductType() {
    var _this$formData2;
    // toggle single product
    if (((_this$formData2 = this.formData) === null || _this$formData2 === void 0 ? void 0 : _this$formData2.productType) === 'simple') {
      this.formData.productsVariation = [];
      this.formData.productsVariation.push(Object.assign({
        enabled: true,
        allowBackOrder: false,
        manageStock: this.formData.manageStock,
        productId: this.formData.id || null,
        productsVariationsAttribute: [{
          productId: this.formData.id || null,
          attributeId: 1,
          attributesValueId: 1
        }],
        unitPrice: 0,
        salePrice: 0,
        profitMargin: 0,
        sku: '',
        stockQuantity: 0,
        stockStatus: 'In Stock'
      }, ...this.savedSimpleVariation // override with saved one
      ));
    } else {
      this.formData.productsVariation = this.savedVariableVariations;
    }
  }
  mounted() {
    this.formData.productType = 'variable'; // enforce 'variable'
    this.emitFormData();
  }
  emitFormData() {
    this.formData.productType = 'variable'; // ensure again
    this.$emit('updated', this.formData);
  }
  async getTaxes() {
    try {
      this.taxes = await (0, _taxes.getTaxes)((0, _utils.getQuery)({
        enabled: true,
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (err) {} // eslint-disable-line  no-empty
  }
  get categoryId() {
    return this.formData.categoryId;
  }
  set categoryId(value) {
    this.$set(this.formData, 'categoryId', value);
  }
  async getBrandsList() {
    try {
      this.brandsList = await (0, _brands.getBrands)((0, _utils.getQuery)({
        enabled: true,
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async getProductsList(query) {
    try {
      this.productsList = await (0, _products.getProducts)((0, _utils.getQuery)({
        enabled: true,
        name: query,
        filter: {
          enabled: 'eq',
          name: '$contL'
        }
      }));
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async getCategoriesList() {
    const tree = await (0, _categories.getCategoriesTree)(); // 🔥 no .data
    if (!tree || !tree.length) {
      console.log('No categories received');
      return;
    }
    const flatten = (categories, level = 0) => {
      return categories.reduce((acc, category) => {
        acc.push({
          id: category.id,
          name: `${'— '.repeat(level)}${category.name}`
        });
        if (category.children && category.children.length) {
          acc.push(...flatten(category.children, level + 1));
        }
        return acc;
      }, []);
    };
    this.categoryList = flatten(tree);
    console.log('Flattened Categories:', this.categoryList);
  }
  setParentCategory(id) {
    for (const parent of this.parentCategories) {
      const found = parent.children.find(child => child.id === id);
      if (found) {
        this.selectedParentId = parent.id;
        break;
      }
    }
  }
  async saveForm(exit = false) {
    this.loading = true;
    try {
      var _this$formData3;
      if (((_this$formData3 = this.formData) === null || _this$formData3 === void 0 ? void 0 : _this$formData3.productType) === 'simple') {
        this.formData.productsVariation[0] = {
          name: this.formData.name,
          unitPrice: this.formData.productsVariation[0].unitPrice,
          salePrice: this.formData.productsVariation[0].salePrice,
          manageStock: this.formData.productsVariation[0].manageStock,
          stockStatus: this.formData.productsVariation[0].stockStatus,
          allowBackOrder: this.formData.productsVariation[0].allowBackOrder,
          stockQuantity: this.formData.productsVariation[0].stockQuantity,
          sku: this.formData.productsVariation[0].sku,
          id: this.formData.productsVariation[0].id
        };
        // update status = In Stock if manageStock and stockQuantity > 0
        if (this.formData.productsVariation[0].manageStock && this.formData.productsVariation[0].stockQuantity > 0) {
          this.formData.productsVariation[0].stockStatus = 'In Stock';
        }
        // update status = Out Of Stock if manageStock and stockQuantity <= 0
        if (this.formData.productsVariation[0].manageStock && this.formData.productsVariation[0].stockQuantity <= 0) {
          this.formData.productsVariation[0].stockStatus = 'Out Of Stock';
        }
      }
      this.formData.categoryId = this.selectedCategoryId;
      let response = {};
      this.formData.relatedProduct = [];
      if (this.selectedRelatedProduct.length > 0) {
        this.selectedRelatedProduct.forEach(value => {
          this.formData.relatedProduct.push({
            id: value
          });
        });
      }
      if (this.isEdit) {
        this.formData.brand = {
          id: this.formData.brandId
        };
        response = await (0, _products.updateProduct)(this.formData.id, this.formData);
        if (exit) {
          _router.default.push({
            path: '/product/list/',
            query: this.$route.query
          });
        } else {
          this.$emit('added', true);
          this.$emit('reload', true);
        }
      } else {
        // Delete unnecessary properties
        delete this.formData.tax;
        delete this.formData.brand;
        // FIXED: Clear existing variations and add only one default variation
        this.formData.productsVariation = [{
          enabled: true,
          allowStepPricing: true,
          allowBackOrder: false,
          manageStock: true,
          productId: null,
          productsVariationsAttribute: [{
            productId: null,
            attributeId: 1,
            attributesValueId: 1
          }],
          unitPrice: 0,
          salePrice: 0,
          profitMargin: 0,
          sku: '',
          stockQuantity: 0,
          stockStatus: 'In Stock'
        }];
        console.log('Variations before save:', JSON.stringify(this.formData.productsVariation));
        // create new product
        response = await (0, _products.createProduct)(this.formData);
        // add delfault attributes for new product
        await (0, _products.updateProductAttributes)(response.id, {
          attribute: [{
            id: 1
          }]
        });
        this.formData = response;
        this.isEdit = true;
        this.emitFormData();
        // to make other tabs available
        this.$emit('edited', this.isEdit);
      }
      this.$notify({
        title: 'Success',
        message: 'Product saved',
        type: 'success',
        duration: 3000
      });
    } catch (err) {
      this.$notify.error({
        title: 'Failed to save',
        message: err + ''
      });
    } finally {
      this.loading = false;
    }
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  showTagInput() {
    this.inputTagVisible = true;
    this.focusTagInput();
  }
  focusTagInput() {
    this.$nextTick(() => {
      this.$refs.saveTagInput.$refs.input.focus();
    });
  }
  handleTagInputConfirm(event) {
    const inputValue = this.inputTagValue;
    if (inputValue) {
      let tags = [];
      if (this.formData.tags) {
        tags = this.formData.tags.split(',');
      }
      // push if not exist
      if (tags.indexOf(inputValue) === -1) {
        // jeff check for case insensitive
        tags.push(inputValue);
      } else {
        this.$message({
          showClose: true,
          message: inputValue + ' already exist!',
          type: 'warning'
        });
      }
      this.formData.tags = tags.join(',');
    }
    this.inputTagValue = '';
    // if entered
    if (event.keyCode && event.keyCode === 13) {
      this.focusTagInput();
    } else {
      this.inputTagVisible = false;
    }
  }
  handleTagClose(tag) {
    const tags = this.formData.tags.split(',');
    this.formData.tags = tags.splice(tags.indexOf(tag), 1).join(',');
  }
  createSlug(title) {
    // Change to lower case
    const titleLower = title.toLowerCase();
    // Trim the last whitespace
    let slug = titleLower.replace(/\s*$/g, '');
    // replace all special characters | symbols with a space
    slug = slug.replace(/[`~!@#$%^&*()_\-+={};:'"\\|,.<>?\s]/g, ' ');
    // Change whitespace to "-"
    slug = slug.replace(/\s+/g, '-');
    this.formData.slug = slug;
  }
  remoteMethod(query) {
    this.getProductsList(query);
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: {}
})], default_1.prototype, "formData", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], default_1.prototype, "saveForm", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'ProductGeneralTab',
  components: {
    HelpText: _index.default,
    Editor: _tinymceVue.default
  }
})], default_1);
var _default = exports.default = default_1;